<template>
  <div class="company">
  
    <h1 v-bg-typography="'h1'">{{ company.name }}</h1>
    <bg-loader :dark="true" v-if="isLoading"></bg-loader>
    <div class="data" v-if="!isLoading">
      <div class="stats" v-if="this.contract[0]">
        <bg-field label="Contract" name="contract">
          <bg-input name="Contract" :value="statusContract" :disabled="true" />
        </bg-field>
        <bg-field label="Tests left" name="tests">
          <bg-input
            name="tests"
            :value="String(this.contract[0].testsLeft)"
            :disabled="true"
          />
        </bg-field>
      </div>

      <div class="addBundle" v-if="addTests">
        <bg-field
          class="field"
          label="Add tests"
          name="start"
          style="min-width: 85px"
        >
          <bg-input v-model="testAmount" type="number" />
        </bg-field>
        <div style="min-width: 200px">
          <bg-select
            :options="bundleOptions"
            @change="onTypeChange"
            :value="testType"
          ></bg-select>
        </div>
      </div>

      <div class="addContract" v-if="addContract"></div>
      <div class="data" v-if="noContract">
        <bg-field
          class="field"
          label="Months"
          name="start"
          style="max-width: 130px"
        >
          <bg-input type="number" v-model="newMonths" />
        </bg-field>
        <bg-button
          variant="primary"
          text="Add contract"
          style="margin-bottom: 30px"
          @click="addContractToCompany"
        />
      </div>
      <bg-button
        variant="primary"
        text="Add products"
        style="margin-bottom: 30px"
        v-if="addTests"
        @click="addBundle"
      />
      <bg-button
        variant="primary"
        text="Add products"
        style="margin-bottom: 30px"
        v-if="!addTests && !noContract"
        @click="
          addTests = true;
          changeContract = false;
        "
      />
    </div>

    <div v-if="!isLoading && contract.length > 0" style="margin-bottom: 30px">
      <bg-field label="Contract" name="contract">
        <List
          :headers="contractList.headers"
          :values="contractList.values"
          :actions="contractList.actions"
          :data="contract"
          :fractions="contractList.fractions"
          :genderIcons="contractList.genderIcons"
          @change="getChanges"
          style="max-width: 900px"
        />
      </bg-field>

      <div class="data" v-if="renewContractMode">
        <bg-field
          class="field addmonth"
          label="Renew contract"
          name="addMonths"
          style="max-width: 130px"
        >
          <bg-input type="number" v-model="addMonths" />
        </bg-field>
        <bg-button
          variant="primary"
          :text="`Add ${addMonths} months`"
          style="margin-bottom: 30px"
          @click="
            renewContractMode = !renewContractMode;
            renewContract();
          "
        />
        <bg-button
          variant="secondary"
          text="Close"
          @click="renewContractMode = false"
          style="margin-bottom: 30px"
        />
      </div>
      <div class="data" v-if="changeContract">
        <bg-field
          class="field"
          label="Start date"
          name="start"
          style="max-width: 130px"
        >
          <bg-input v-model="editStart" ref="start" />
        </bg-field>
        <bg-field
          class="field"
          label="End date"
          name="end"
          style="max-width: 130px"
        >
          <bg-input v-model="editEnd" />
        </bg-field>
        <bg-button
          variant="primary"
          text="Save"
          @click="saveContract"
          style="margin-bottom: 30px"
        />
        <bg-button
          variant="secondary"
          text="Close"
          @click="changeContract = false"
          style="margin-bottom: 30px"
        />
      </div>
    </div>
    <div v-if="bundles.length > 0">
      <bg-field label="Bundles" name="contract">
        <List
          :headers="bundleList.headers"
          :values="bundleList.values"
          :actions="bundleList.actions"
          :data="bundles"
          :fractions="bundleList.fractions"
          :genderIcons="bundleList.genderIcons"
          @change="getChanges"
          style="margin-bottom: 30px; max-width: 900px"
        />
      </bg-field>
    </div>

    <bg-modal
      v-if="isModalOpen"
      body="Are you sure you want to remove this bundle?"
      @close="isModalOpen = false"
    >
      <bg-button
        variant="secondary"
        text="Cancel"
        @click="isModalOpen = false"
      />
      <bg-button
        variant="destructive"
        class="action"
        text="Delete"
        @click="deleteBundle"
      />
    </bg-modal>
  </div>
</template>

<style scoped>
@import "./styles.scss";
</style>

<script>
import BgTypography from "@/directives/bg-typography";
import API from "@/api";
import List from "@/components/list";
import BgButton from "@/components/bg-button";
import BgField from "@/components/bg-field";
import BgInput from "@/components/bg-input";
import moment from "moment";
import BgSelect from "@/components/bg-select";
import BgLoader from "@/components/bg-loader";
import BgModal from "@/components/bg-modal";

export default {
  name: "Contract",
  components: {
    List,
    BgButton,
    BgField,
    BgInput,
    BgSelect,
    BgLoader,
    BgModal,
  },
  directives: {
    BgTypography,
  },
  created() {
    this.fetchData();
  },
  data() {
    return {
      addMonths: 0,
      addTests: false,
      addContract: false,
      bundleList: {
        headers: ["Type", "Amount", "Requested"],
        values: ["type", "amount", "requested"],
        fractions: [1, 1, 1],
        genderIcons: false,
        actions: ["Delete"],
      },
      bundleOptions: ["Professional", "Essential"],
      bundles: [],
      changeContract: false,
      company: {},
      contract: [],
      contractList: {
        headers: ["Product", "Start", "End"],
        values: ["product", "start_formatted", "end_formatted"],
        fractions: [1, 1, 1],
        genderIcons: false,
        actions: ["Renew"],
      },
      deleteBundleId: null,
      editContract: {},
      editStart: "",
      editEnd: "",
      isLoading: false,
      isModalOpen: false,
      listMode: true,
      months: 0,
      newMonths: 0,
      noContract: false,
      renewContractMode: false,
      statusContract: "",
      testAmount: 1,
      testType: "Professional",
    };
  },
  methods: {
    async addBundle() {
      this.isLoading = true;
      let amount = this.testAmount;
      let type = this.testType.toLowerCase();
      const bundle = {
        test_type: type,
        tests: amount,
        comments: "",
        contract_id: this.contract[0].id,
      };
      await API.user.createBundle(bundle);
      this.testAmount = 0;
      this.fetchData();
      this.$store.dispatch("fetchAllCompanies");
      this.addTests = false;
      this.isLoading = false;
    },
    async addContractToCompany() {
      this.isLoading = true;
      let start = moment().format("YYYY-MM-DD");
      let end = moment()
        .add(this.addMonths, "month")
        .format("YYYY-MM-DD");

      const contract = {
        start_date: start,
        end_date: end,
        comments: "",
        company_id: this.$route.params.id,
      };

      await API.user.createContract(contract);
      this.fetchData();
      this.noContract = false;
      this.isLoading = false;
    },
    changeStatus() {
      if (this.contract[0]) {
        const diff = moment().diff(this.contract[0].end, "days");
        if (diff < 0) {
          this.statusContract = "Active";
        } else {
          this.statusContract = "Not active";
        }
      }
    },
    async deleteBundle() {
      await API.user.deleteBundle(this.deleteBundleId);
      this.isModalOpen = false;
      this.deleteBundleId = null;
      this.fetchData();
    },
    async fetchData() {
      this.isLoading = true;
      this.contract = [];
      this.bundles = [];
      this.company = await API.user.getCompany(this.$route.params.id);

      if (this.company.contracts.length > 1) {
        let latest = 0;
        this.company.contracts.forEach((obj, index) => {
          if (obj.end_date > this.company.contracts[latest].end_date) {
            latest = index;
          }
        });

        this.contract.push({
          product: "Brainpeek subscription",
          start: this.company.contracts[latest].start_date,
          start_formatted: moment(
            this.company.contracts[latest].start_date
          ).format("DD-MM-YYYY"),
          end: this.company.contracts[latest].end_date,
          end_formatted: moment(this.company.contracts[latest].end_date).format(
            "DD-MM-YYYY"
          ),
          active: this.company.contracts[latest].is_active,
          testsLeft:
            this.company.contracts[latest].available_tests.essential +
            this.company.contracts[latest].available_tests.professional,
          id: this.company.contracts[latest].id,
        });
      } else if (this.company.contracts.length < 1) {
        this.noContract = true;
      } else {
        this.contract.push({
          product: "Brainpeek subscription",
          start: this.company.contracts[0].start_date,
          start_formatted: moment(this.company.contracts[0].start_date).format(
            "DD-MM-YYYY"
          ),
          end: this.company.contracts[0].end_date,
          end_formatted: moment(this.company.contracts[0].end_date).format(
            "DD-MM-YYYY"
          ),
          active: this.company.contracts[0].is_active,
          testsLeft:
            this.company.contracts[0].available_tests.essential +
            this.company.contracts[0].available_tests.professional,
          id: this.company.contracts[0].id,
        });
      }

      if (this.company.contracts.length > 0) {
        this.company.contracts.forEach((contract) => {
          contract.bundles.forEach((bundle) => {
            let type;
            if (bundle.test_type === "professional") {
              type = "Professional tests";
            } else if (bundle.test_type === "essential") {
              type = "Essential tests";
            }
            this.bundles.push({
              type: type,
              requested: moment(bundle.created_at).format("DD-MM-YYYY"),
              amount: bundle.tests,
              id: bundle.id,
            });
          });
        });
      }

      this.changeStatus();

      this.isLoading = false;
    },
    getChanges(val) {
      if (val.action === "Select") {
        if (val.item.product === "Brainpeek subscription") {
          this.renewContractMode = false;
          this.addTests = false;
          this.changeContract = true;
          this.editStart = moment(val.item.start).format("DD-MM-YYYY");
          this.editEnd = moment(val.item.end).format("DD-MM-YYYY");
          this.editContract = this.company.contracts.find(
            (obj) => obj.id === val.item.id
          );
        }
      } else if (val.action === "Renew") {
        this.changeContract = false;
        this.addTests = false;
        this.renewContractMode = true;
        this.editContract = this.company.contracts.find(
          (obj) => obj.id === val.item.id
        );
      } else if (val.action === "Delete") {
        this.deleteBundleId = val.item.id;
        this.isModalOpen = true;
      }
    },
    onTypeChange(val) {
      this.testType = val;
    },
    async renewContract() {
      let extension = this.addMonths;
      let newEnd = moment(this.contract[0].end)
        .add(extension, "month")
        .format("YYYY-MM-DD");
      this.contract[0].end = String(newEnd);
      this.editContract.end_date = String(newEnd);
      this.changeStatus();
      this.addMonths = 0;
      await API.user.updateContract(
        this.editContract.id,
        this.editContract
      );
      this.fetchData();
    },
    async saveContract() {
      this.isLoading = true;
      this.editContract.end_date = moment(this.editEnd, "DD-MM-YYYY").format(
        "YYYY-MM-DD"
      );
      this.editContract.start_date = moment(
        this.editStart,
        "DD-MM-YYYY"
      ).format("YYYY-MM-DD");
      await API.user.updateContract(this.editContract.id, this.editContract);
      this.fetchData();
      this.changeContract = false;
      this.isLoading = false;
    },
  },
};
</script>
